import { UserAcl, GroupAcl } from '../../types/interfaces';
import { FrontEndModel } from "./FrontEndModel";

export class AccessControlledModel extends FrontEndModel {
	users: UserAcl[] = [];
	groups: GroupAcl[] = [];
}
